/*
 * random-products.js (toserof) — Ürün listelerini "her ziyarette farklı ürünler" gelecek
 * şekilde rastgeleleştirir. Shopify'da native random sort yok; bu yüzden:
 *   - Koleksiyon/Arama: varsayılan görünümde RASTGELE SAYFA dilimi çekilir (Section Rendering
 *     API) + grid içi Fisher-Yates karıştırılır → koleksiyonun derinindeki ürünler de gelir.
 *   - Ana sayfa "featured" slider: kaynak koleksiyonun rastgele sayfasından N kart çekilir,
 *     slaytlar yeniden kurulur (fetch hata verirse mevcut slaytlar karıştırılır).
 * Kullanıcı sıralama/filtre/sayfa seçtiyse koleksiyon/aramada niyete saygı duyulur (random YOK).
 * Hedef konteyner yoksa modüller sessizce no-op olur. Tek sefer çalışır (guard).
 * MARKA SERPİŞTİRME: karıştırma marka-farkındadır (data-vendor) — sayfa bileşimi
 * havuzdan dengeli örneklenir (samplePage) ve sıra "3'lü seri yasak, ikili seyrek"
 * kuralıyla doğal-rastgele kurulur (mekanik ritim yok). Koleksiyon + arama +
 * featured slider'da geçerli.
 */
(function () {
  "use strict";
  if (window.__toserofRandomProducts) return;
  window.__toserofRandomProducts = true;

  var internal = false; // kendi DOM değişikliklerimizi MutationObserver'dan gizle

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  // Kartın markasını data-vendor'dan okur (kendisi ya da içindeki bir eleman).
  // Boş/eksik marka tek bir "markasız" grubuna düşer.
  function readVendor(el) {
    var v = el.getAttribute ? el.getAttribute("data-vendor") : null;
    if (!v && el.querySelector) {
      var inner = el.querySelector("[data-vendor]");
      if (inner) v = inner.getAttribute("data-vendor");
    }
    v = (v || "").replace(/\s+/g, " ").trim().toLowerCase();
    return v || "__novendor__";
  }

  // "Markalar karışsın ama DOĞAL dursun" — ağırlıklı rastgele KURUCU:
  // her adımda kalan kart sayısına göre rastgele bir marka seçilir; bir önceki
  // markanın hemen tekrarının ihtimali KISILIR (ikili olur ama seyrek), üçlü
  // seri YASAK (başka marka kalmadıysa mecburen). Böylece ne katı "hiç yan
  // yana olmasın" kuralının ürettiği mekanik "2 ürün + 1 ayraç" ritmi, ne de
  // düz shuffle'ın uzun tek-marka blokları oluşur; desen organik görünür.
  // data-vendor hiç yoksa (tek grup) davranış düz shuffle ile aynıdır.
  var PAIR_DAMP = 0.25; // önceki markanın hemen tekrarı için ağırlık çarpanı (küçük=ikili daha seyrek)
  function interleaveByVendor(items) {
    var groups = {}, keys = [];
    items.forEach(function (el) {
      var k = readVendor(el);
      if (!groups[k]) { groups[k] = []; keys.push(k); }
      groups[k].push(el);
    });
    if (keys.length < 2) return shuffle(items.slice());
    keys.forEach(function (k) { shuffle(groups[k]); });
    var out = [], lastK = null, runLen = 0, total = items.length;
    while (out.length < total) {
      var cand = [], wts = [], totW = 0, i, k, w;
      for (i = 0; i < keys.length; i++) {
        k = keys[i];
        var r = groups[k].length;
        if (!r) continue;
        if (k === lastK) {
          if (runLen >= 2) continue; // üçlü seri engeli
          w = r * PAIR_DAMP;         // ikili mümkün ama seyrek
        } else { w = r; }
        cand.push(k); wts.push(w); totW += w;
      }
      var pick;
      // İLERİYE BAKIŞ: bir markanın kalanı "araya 2'şerli dizilebilir" sınırına
      // dayandıysa onu önceliklendir — yoksa sona tek marka yığılır ve mecburi
      // 3'lü seri oluşur (kuyruk bloğu).
      var rem = total - out.length, domK = null, domR = 0;
      for (i = 0; i < keys.length; i++) { var rr = groups[keys[i]].length; if (rr > domR) { domR = rr; domK = keys[i]; } }
      if (!cand.length) { pick = lastK; } // sadece son marka kaldı → kaçınılmaz
      else if (domK && domR >= 2 * (rem - domR) + 1 && !(domK === lastK && runLen >= 2)) {
        pick = domK;
      } else {
        var t = Math.random() * totW;
        for (i = 0; i < cand.length; i++) { t -= wts[i]; if (t <= 0) break; }
        pick = cand[Math.min(i, cand.length - 1)];
      }
      out.push(groups[pick].pop());
      if (pick === lastK) { runLen++; } else { lastK = pick; runLen = 1; }
    }
    return out;
  }

  // Havuzdan SAYFA SEÇİMİ: markalardan eşit paylı turlarla topla — azınlık
  // markaların tamamı sayfaya girer, kalan boşluğu baskın marka doldurur.
  // Sayfa bileşimi olabildiğince dengelenir; "2 ürün arasına 1 farklı marka"
  // ritminin asıl kökü olan BASKINLIK böylece kırılır.
  function samplePage(pool, limit) {
    if (!limit || pool.length <= limit) return pool.slice();
    var groups = {}, keys = [];
    pool.forEach(function (el) {
      var k = readVendor(el);
      if (!groups[k]) { groups[k] = []; keys.push(k); }
      groups[k].push(el);
    });
    keys.forEach(function (k) { shuffle(groups[k]); });
    var out = [];
    while (out.length < limit) {
      shuffle(keys); // her turda marka önceliği rastgele
      var got = false;
      for (var i = 0; i < keys.length && out.length < limit; i++) {
        var g = groups[keys[i]];
        if (g.length) { out.push(g.pop()); got = true; }
      }
      if (!got) break;
    }
    return out;
  }

  // SON GARANTİ: kurulan sırada kalmış 3'lü seri varsa ortadaki kartı, yeni bir
  // 3'lü oluşturmayan rastgele bir konumla takas ederek kır (ikililer serbest).
  function breakTriples(arr) {
    var keys = arr.map(readVendor), n = arr.length;
    for (var i = 2; i < n; i++) {
      if (!(keys[i] === keys[i - 1] && keys[i] === keys[i - 2])) continue;
      var mid = i - 1, k = keys[mid];
      var start = Math.floor(Math.random() * n);
      for (var s = 0; s < n; s++) {
        var j = (start + s) % n;
        if (j >= i - 2 && j <= i) continue;
        var kj = keys[j];
        if (kj === k) continue;
        // gelen kart (kj) mid'de 3'lü kurmasın: iki komşusu da kj olmasın
        if (keys[mid - 1] === kj && keys[mid + 1] === kj) continue;
        if (mid - 2 >= 0 && keys[mid - 1] === kj && keys[mid - 2] === kj) continue;
        if (mid + 2 < n && keys[mid + 1] === kj && keys[mid + 2] === kj) continue;
        // giden kart (k) j'de 3'lü kurmasın
        if (j - 1 >= 0 && keys[j - 1] === k && ((j - 2 >= 0 && keys[j - 2] === k) || (j + 1 < n && keys[j + 1] === k))) continue;
        if (j + 1 < n && keys[j + 1] === k && j + 2 < n && keys[j + 2] === k) continue;
        var t = arr[mid]; arr[mid] = arr[j]; arr[j] = t;
        t = keys[mid]; keys[mid] = keys[j]; keys[j] = t;
        break;
      }
    }
    return arr;
  }

  // Tüm liste karıştırmaları buradan geçer: marka-farkında doğal sıralama.
  function orderItems(items) { return breakTriples(interleaveByVendor(items)); }

  function directChildren(container, selector) {
    return Array.prototype.filter.call(container.children, function (el) {
      return el.matches && el.matches(selector);
    });
  }

  function shuffleInto(container, items, updateFn) {
    if (!container || items.length < 2) { if (updateFn) updateFn(); return; }
    internal = true;
    var frag = document.createDocumentFragment();
    orderItems(items).forEach(function (el) { frag.appendChild(el); });
    container.appendChild(frag);
    if (updateFn) updateFn();
    setTimeout(function () { internal = false; }, 0);
  }

  function hasUserOrdering() {
    var p = new URLSearchParams(window.location.search);
    if (p.get("sort_by")) return true;
    var page = p.get("page");
    if (page && page !== "1") return true;
    var filtered = false;
    p.forEach(function (v, k) { if (k.indexOf("filter.") === 0) filtered = true; });
    return filtered;
  }

  /* ---------------- KOLEKSİYON / ARAMA ---------------- */
  function randomizeGrid() {
    var grid = document.getElementById("product-grid");
    var container = document.getElementById("ProductGridContainer");
    if (!grid || !container) { revealGrid(); return; }

    observeContainer(container);

    // random hazır olana dek grid gizliyse aç (flash olmasın). settled: tek-seferlik kilit —
    // safety açtıysa GEÇ gelen random SWAP EDİLMEZ (gecikmiş flash olmaz).
    var settled = false;
    function done() { if (settled) return; settled = true; clearTimeout(safety); revealGrid(); }
    // fetch çok uzarsa son çare: eldeki grid'i AÇMADAN ÖNCE (hâlâ gizliyken) marka-farkında
    // serpiştir, sonra göster — ham marka-bloklu sıra hiç görünmesin. (Kullanıcı sıralaması
    // varsa done() zaten anında çağrılıp settled olur; safety o durumda hiç tetiklenmez.)
    var safety = setTimeout(function () { try { shuffleCurrent(); } catch (e) {} done(); }, 2500);

    if (hasUserOrdering()) { done(); return; } // kullanıcı niyeti — dokunma (grid zaten gizlenmedi)

    var count = parseInt(grid.getAttribute("data-products-count") || "0", 10);
    var per = parseInt(grid.getAttribute("data-per-page") || "0", 10);
    var sectionId = grid.getAttribute("data-id");
    var totalPages = (count > 0 && per > 0) ? Math.ceil(count / per) : 1;

    function shuffleCurrent() {
      var g = document.getElementById("product-grid");
      if (g) shuffleInto(g, directChildren(g, ".collection__grid__item"));
    }

    if (totalPages <= 1 || !sectionId) { shuffleCurrent(); done(); return; }

    // TEK rastgele pencere yerine BİRDEN FAZLA (3'e kadar) farklı rastgele sayfadan
    // kart HAVUZU topla: koleksiyon marka-bloklu dizildiği için tek pencere çoğu kez
    // tek markanın bölgesine denk geliyordu ("üstte hep aynı marka"). Farklı pencereler
    // birlikte karıştırılınca sayfanın başı da gerçekten markalar-arası karışık olur.
    var wanted = Math.min(3, totalPages);

    function randomPicks() {
      var out = [];
      while (out.length < wanted) {
        var R = 1 + Math.floor(Math.random() * totalPages);
        if (out.indexOf(R) === -1) out.push(R);
      }
      return out;
    }

    // KARIŞIM HARİTASI (assets/mix-map.json — _yakup-mix-map.mjs üretir): her sayfanın
    // baskın markası önceden çıkarılmıştır. Pencereleri FARKLI markaların bölgelerinden
    // (veya -1 = zaten karışık sayfalardan) seç → havuz her zaman çok markalı olur.
    // Harita yok / bayat / sayfa-boyu uyumsuz / geç geldi → rastgele seçime düşülür.
    function mappedPicks(mapData) {
      try {
        var handle = grid.getAttribute("data-collection-handle");
        if (!mapData || !handle || mapData.pageSize !== per) return null;
        var dom = mapData.c && mapData.c[handle];
        if (!dom || dom.length < 2) return null;
        var P = Math.min(dom.length, totalPages);
        var order = [];
        for (var i = 0; i < P; i++) order.push(i);
        shuffle(order);
        var chosen = [], seen = {};
        for (var j = 0; j < order.length && chosen.length < wanted; j++) {
          var pg = order[j], k = dom[pg];
          if (k === -1 || !seen[k]) { chosen.push(pg + 1); if (k !== -1) seen[k] = true; }
        }
        for (var j2 = 0; j2 < order.length && chosen.length < wanted; j2++) {
          if (chosen.indexOf(order[j2] + 1) === -1) chosen.push(order[j2] + 1);
        }
        return chosen.length ? chosen : null;
      } catch (e) { return null; }
    }

    function fetchPage(p) {
      var qs = new URLSearchParams(window.location.search);
      qs.set("section_id", sectionId);
      qs.set("page", String(p));
      return fetch(window.location.pathname + "?" + qs.toString(), { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
        .then(function (html) {
          var c = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer");
          if (!c) throw "no-container";
          return c;
        })
        .catch(function () { return null; }); // tek sayfa hatası havuzu iptal etmesin
    }

    // Haritayı KISA zaman bütçesiyle çek (küçük dosya, CDN önbellekli) — gecikirse
    // rastgele pencere seçimine düşülür, toplam süre bütçesi (2.5sn safety) korunur.
    var mapUrl = grid.getAttribute("data-mix-map");
    var mapPromise = mapUrl
      ? Promise.race([
          fetch(mapUrl).then(function (r) { return r.ok ? r.json() : null; }),
          new Promise(function (res) { setTimeout(function () { res(null); }, 900); }),
        ]).catch(function () { return null; })
      : Promise.resolve(null);

    mapPromise.then(function (mapData) {
      if (settled) return;
      var picks = mappedPicks(mapData) || randomPicks();
      run(picks);
    });

    function run(picks) {
      Promise.all(picks.map(fetchPage)).then(function (containers) {
      if (settled) return; // safety zaten 1.sayfayı açtı → geç random'ı swap etme (flash olmaz)
      containers = containers.filter(Boolean);
      if (!containers.length) { shuffleCurrent(); done(); return; }
      var pool = [];
      containers.forEach(function (c) {
        var g = c.querySelector("#product-grid");
        if (g) pool = pool.concat(directChildren(g, ".collection__grid__item"));
      });
      internal = true;
      container.innerHTML = containers[0].innerHTML; // araç çubuğu/sayaç/sayfalama birincil sayfadan
      var g2 = document.getElementById("product-grid");
      if (g2 && pool.length) {
        // birincil sayfanın kopya kartlarını çıkar; havuzdan DENGELİ seçilmiş
        // sayfayı doğal-karışık sırayla bas
        directChildren(g2, ".collection__grid__item").forEach(function (el) { el.parentNode.removeChild(el); });
        var mixed = orderItems(samplePage(pool, per > 0 ? per : pool.length));
        if (per > 0) mixed = mixed.slice(0, per);
        var frag = document.createDocumentFragment();
        mixed.forEach(function (el) { frag.appendChild(el); });
        g2.appendChild(frag);
        setTimeout(function () { internal = false; }, 0);
        done();
      } else {
        setTimeout(function () { internal = false; }, 0);
        shuffleCurrent();
        done();
      }
      });
    }
  }

  function revealGrid() { document.documentElement.classList.remove("toserof-grid-pending"); }

  // facets.js filtre/sıralama sonrası #ProductGridContainer'ı değiştirir → varsayılan görünümde
  // grid'i tekrar karıştır (re-fetch etmeyiz; kullanıcı seçtiyse niyete saygı).
  function observeContainer(container) {
    if (container.__toserofObserved) return;
    container.__toserofObserved = true;
    var obs = new MutationObserver(function () {
      if (internal) return;
      if (hasUserOrdering()) return;
      var g = document.getElementById("product-grid");
      if (g) shuffleInto(g, directChildren(g, ".collection__grid__item"));
    });
    obs.observe(container, { childList: true });
  }

  /* ---------------- ANA SAYFA FEATURED SLIDER ---------------- */
  function randomizeFeatured() {
    var roots = document.querySelectorAll("[data-random-featured]");
    Array.prototype.forEach.call(roots, function (root) {
      var cont = root.querySelector("[data-swiper-container]");
      if (!cont) return;
      var slides = directChildren(cont, "[data-swiper-slide]");
      if (!slides.length) return;
      var slideshow = root.querySelector("slideshow-section") || root.closest("slideshow-section");
      var handle = (root.getAttribute("data-source-collection") || "").trim();
      var want = slides.length;

      function swiperUpdate() {
        var sw = slideshow && slideshow.swiper;
        if (!sw) return;
        try {
          if (sw.params && sw.params.loop && sw.loopDestroy && sw.loopCreate) { sw.loopDestroy(); sw.loopCreate(); }
          sw.update();
          sw.slideTo(0, 0, false);
        } catch (e) {}
      }
      // done: tek seferlik kilit. Önce hangisi biterse (random build / safety) o kazanır;
      // safety açtıysa GEÇ gelen random SWAP EDİLMEZ → varsayılan kalır, gecikmiş flash OLMAZ.
      var done = false;
      function reveal() { root.classList.add("random-ready"); }
      function finish(buildFn) {
        if (done) return;
        done = true;
        clearTimeout(safety);
        internal = true;
        if (buildFn) { try { buildFn(); } catch (e) {} }
        reveal();
        setTimeout(function () { internal = false; }, 0);
      }
      function doShuffle() { shuffleInto(cont, slides, swiperUpdate); }

      // 5sn'de random hâlâ gelmediyse son çare: eldeki slaytları (gizliyken) marka-farkında
      // karıştırıp göster — geç gelen random yine swap edilmez.
      var safety = setTimeout(function () { finish(doShuffle); }, 5000);

      if (!handle) { finish(doShuffle); return; }

      var col = "/collections/" + encodeURIComponent(handle);
      // 1. sayfa + FARKLI bir rastgele sayfadan kart havuzu (tek pencere çoğu kez tek
      // markanın bloğuna denk geliyordu) → slaytlar markalar-arası karışık seçilir.
      fetchGrid(col + "?page=1")
        .then(function (g1) {
          var count = parseInt(g1.getAttribute("data-products-count") || "0", 10);
          var per = parseInt(g1.getAttribute("data-per-page") || "0", 10) || 1;
          var pages = count > 0 ? Math.ceil(count / per) : 1;
          var cards = directChildren(g1, ".collection__grid__item");
          if (pages <= 1) return cards;
          var R = 2 + Math.floor(Math.random() * (pages - 1)); // 1 hariç rastgele sayfa
          return fetchGrid(col + "?page=" + R)
            .then(function (g2) { return cards.concat(directChildren(g2, ".collection__grid__item")); })
            .catch(function () { return cards; }); // ikinci sayfa hata verirse eldekiyle devam
        })
        .then(function (cards) {
          if (!cards.length) { finish(doShuffle); return; }
          finish(function () { buildSlides(cards); });
        })
        .catch(function () { finish(doShuffle); });

      function buildSlides(cards) {
        var picked = orderItems(samplePage(cards, want)).slice(0, want);
        slides.forEach(function (s) { s.remove(); });
        picked.forEach(function (card) {
          var slide = document.createElement("div");
          slide.setAttribute("data-swiper-slide", "");
          var vend = card.getAttribute && card.getAttribute("data-vendor");
          if (vend) slide.setAttribute("data-vendor", vend);
          slide.className = "swiper-slide";
          var inner = document.createElement("div");
          inner.setAttribute("data-cascade", "");
          inner.innerHTML = card.innerHTML; // color-swatch kartı (custom element otomatik upgrade)
          slide.appendChild(inner);
          cont.appendChild(slide);
        });
        swiperUpdate();
      }
    });
  }

  function fetchGrid(url) {
    return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
      .then(function (html) {
        var g = new DOMParser().parseFromString(html, "text/html").getElementById("product-grid");
        if (!g) throw "no-grid";
        return g;
      });
  }

  function init() {
    try { randomizeGrid(); } catch (e) {}
    try { randomizeFeatured(); } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
